import React from "react";
import {useDispatch, useSelector} from "react-redux";
import ButtonCircle from "../../../../components/Common/ButtonCircle";
import {selectMacroareas} from "../../../../slices/profile";
import AddIcon from "@material-ui/icons/Add";
import {openDialog} from "../../../../slices/dialog";
import {deleteCompanyMacroarea,} from "../../../../api/company/macroArea";
import {openAlert} from "../../../../slices/alert";
import "./style.scss";
import {IconButton, Tooltip} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import {EditCompanyMacroarea} from "./EditCompanyMacroarea";
import {AddCompanyMacroarea} from "./AddCompanyMacroarea";
import {ConfirmAction} from "../../../../components/CommonComponents";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import {useTranslation} from "react-i18next";

const CompanyMacroareas = ({selectMacroarea, selectedMacroarea}) => {
    const macroareas = useSelector(selectMacroareas);
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const onAddMacro = () => {
        dispatch(
            openDialog({
                Content: AddCompanyMacroarea,
                title: t("company_addMacro_title"),
                props: {},
                closable: true,
            })
        );
    };

    const onDeleteMacro = () => {
        if (!selectedMacroarea) return;

        const action = () => {
            deleteCompanyMacroarea(selectedMacroarea.id)
                .then(() => {
                    selectMacroarea();
                })
                .catch((error) =>
                    dispatch(openAlert({type: "error", message: t("alert_generic_error")}))
                );
        };

        dispatch(
            openDialog({
                Content: ConfirmAction,
                title: "Conferma",
                props: {
                    action,
                },
                closable: false,
            })
        );
    };

    const onEditMacro = () => {
        dispatch(
            openDialog({
                Content: EditCompanyMacroarea,
                title: t("company_editMacro_title"),
                props: {
                    macroarea: selectedMacroarea,
                },
                closable: true,
            })
        );
    };

    return (
        <div className="companyMacroareas">
            <div className="companyMacroareas__list card">
                {selectedMacroarea && (
                    <button onClick={() => selectMacroarea()}>
                        <ArrowBackIcon color="primary"/>
                    </button>
                )}
                <section>
                    <header>
                        <h3>{t("company_vivaio_macro_title")}</h3>
                        <Tooltip
                            title={t("company_vivaio_macro_info") as string}
                            aria-label="info"
                        >
                            <InfoOutlinedIcon fontSize="small" color="primary"/>
                        </Tooltip>
                    </header>
                    <ul>
                        {macroareas.length === 0 && <p>{t("company_vivaio_macro_none")}</p>}
                        {macroareas.map((macro) => (
                            <li
                                className={macro.id === selectedMacroarea?.id ? "active" : ""}
                                onClick={() => selectMacroarea(macro)}
                            >
                                {macro.name}
                            </li>
                        ))}
                        <ButtonCircle onClick={onAddMacro}>
                            <AddIcon/>
                        </ButtonCircle>
                    </ul>
                </section>
            </div>
            {selectedMacroarea && (
                <div className="companyMacroareas__detail card">
                    <header>
                        <h2>{selectedMacroarea.name}</h2>
                        <IconButton aria-label="edit" onClick={onEditMacro}>
                            <EditIcon fontSize="small"/>
                        </IconButton>
                        <IconButton aria-label="delete" onClick={onDeleteMacro}>
                            <DeleteIcon fontSize="small"/>
                        </IconButton>
                    </header>
                    <h3>{t("company_vivaio_desc_label")}</h3>
                    {selectedMacroarea?.description ? <div className="text"
                                                           dangerouslySetInnerHTML={{__html: selectedMacroarea?.description}}/> : t("company_vivaio_desc_none")}
                </div>
            )}
        </div>
    );
};

export default CompanyMacroareas;
